<template>
  <div id="news">
    <div class="">
      <ol class="breadcrumb">
        <li>
          <a href="#/dashboard">Dashboard</a>
        </li>
        <li class="active">
          <a href="#/managernews">Manager News</a>
        </li>
        <li class="active">
          <a v-if="isEdit">Edit Post</a>
          <a v-else>New Post</a>
        </li>
      </ol>
    </div>
    <div class="content login middle" v-loading="loading">
      <div class="cell">
        <div class="container pb100">
          <div class="row mt50">
            <a href="#/managernews/" class="font16 backto hidden-xs">
              <i class="iconfont3 icon-back"></i> BACK TO NEWS LIST
            </a>

            <div class="row">
              <div class="col-xs-12 text-center">
                <el-form
                  :model="post"
                  ref="post"
                  status-icon
                  validate-on-rule-change
                >
                  <div class="col-xs-12">
                    <el-form-item
                      class="white"
                      prop="title"
                      :rules="[
                        { required: true, message: 'Title is required!' },
                      ]"
                    >
                      <el-input
                        v-model="post.title"
                        size="big"
                        placeholder="A new post title here"
                        class="mt20"
                      ></el-input>
                    </el-form-item>
                    <el-form-item
                      class="white"
                      prop="tag"
                      :rules="[{ required: true, message: 'Tag is required!' }, {max: 30 ,message: 'Maximum length should is 30'}]"
                    >
                      <el-input
                        list="tags"
                        v-model="post.tag"
                        size="big"
                        placeholder="A new post tag here"
                        class="mt20"
                      ></el-input>
                      <datalist id="tags"></datalist>
                    </el-form-item>
                  </div>
                  <div class="col-xs-9">
                    <el-tiptap
                      lang="en"
                      class="mt20"
                      height="500px"
                      v-model="post.content"
                      :extensions="extensions"
                    />
                  </div>
                  <div class="col-xs-3 mt20">
                    <el-form-item
                      class="white"
                      prop="file_name"
                      :rules="[
                        {
                          required: !this.isEdit,
                          message: 'Thumbnail is required!',
                        },
                      ]"
                    >
                      <div
                        style="height: 445px; border: 1px solid #dcdfe6"
                        class="center"
                      >
                        <img
                          style="width: 100%; max-height: 445px"
                          id="preview"
                          ref="preview"
                          :src="thumbnail_url"
                          alt="your image"
                        />
                      </div>
                      <el-input
                        type="file"
                        id="file"
                        v-model="post.file_name"
                        placeholder="A new post tag here"
                        class="mt20"
                        @input="handle_file_upload"
                      ></el-input>
                    </el-form-item>
                  </div>
                </el-form>
                <div class="col-xs-12 mt20">
                  <button
                    v-if="isEdit"
                    type="button"
                    class="ebutton"
                    @click="edit()"
                  >
                    Edit Post
                  </button>
                  <button v-else type="button" class="ebutton" @click="add()">
                    Add Post
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.el-tiptap-editor__menu-bar,
.el-tiptap-editor__footer {
  border-radius: 0px !important;
}
</style>
<script>
import axios from "axios";
import "../assets/css/news.css";
import "element-tiptap/lib/index.css";
import {
  ElementTiptap,
  Doc,
  Text,
  Paragraph,
  Heading,
  Bold,
  Underline,
  Italic,
  Strike,
  ListItem,
  BulletList,
  OrderedList,
  Image,
  Link,
  TextAlign,
  Indent,
  LineHeight,
  HorizontalRule,
  History,
} from "element-tiptap";

export default {
  name: "newpost",
  components: {
    "el-tiptap": ElementTiptap,
  },
  props: {
    editingPost: Object,
  },
  watch: {
    editingPost: {
      handler(newVal) {
        if (typeof newVal != "undefined") {
          this.isEdit = true;
          this.thumbnail_url =
            this.$store.state.serverURL +
            "/" +
            newVal.file_name +
            "?" +
            Date.now();
          newVal.file_name = "";
          this.post = newVal;
        } else {
          this.isEdit = false;
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      isEdit: false,
      post: {
        title: "",
        tag: "",
        content: "",
        created_by_uid: "",
        created_at: null,
        file_name: "",
      },
      thumbnail_url: "",
      file: {},
      extensions: [
        new Doc(),
        new Text(),
        new Paragraph(),
        new Heading({ level: 5 }),
        new Bold({ bubble: true }), // render command-button in bubble menu.
        new Underline({ bubble: true, menubar: false }), // render command-button in bubble menu but not in menubar.
        new Italic(),
        new Strike(),
        new ListItem(),
        new BulletList(),
        new OrderedList(),
        new Link(),
        new Image(),
        new TextAlign(),
        new Indent(),
        new LineHeight(),
        new HorizontalRule(),
        new History(),
      ],
      loading: false,
    };
  },
  mounted() {
    this.get_tags();
  },
  methods: {
    handle_file_upload() {
      this.file = document.getElementById("file").files[0];
      var reader = new FileReader();
      reader.onload = (e) => {
        this.$refs.preview.setAttribute("src", e.target.result);
      };
      reader.readAsDataURL(this.file); // convert to base64 string
    },
    get_tags() {
      axios
        .get("/news/tags")
        .then((response) => {
          var datalist = document.getElementById("tags");
          for (var tag of response.data) {
            let option = document.createElement("option");
            option.innerHTML = tag;
            datalist.append(option);
          }
        })
        .catch(function (error) {
          alert(error);
        });
    },
    add() {
      this.$refs.post.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.post.created_by_uid = this.$store.state.user._id;
          this.post.created_at = new Date();
          let formData = new FormData();
          formData.append("file", this.file);
          for (var attr in this.post) {
            formData.append(attr, this.post[attr]);
          }
          axios
            .post("/news/add/", formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((res) => {
              if (res.data.ok == 1) {
                this.$message({
                  type: "success",
                  message: "Created!",
                });
                this.loading = false;
                this.$router.go(-1);
              } else {
                this.$message({
                  type: "error",
                  message: "Create Failed!",
                });
                this.loading = false;
              }
            })
            .catch(function (error) {
              alert(error);
              this.loading = false;
            });
        }
      });
    },
    edit() {
      this.$refs.post.validate((valid) => {
        if (valid) {
          this.loading = true;
          let formData = new FormData();
          if (this.file instanceof File) {
            formData.append("file", this.file);
          }
          for (var attr in this.post) {
            formData.append(attr, this.post[attr]);
          }
          axios
            .put("/news/" + this.post._id, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((res) => {
              if (res.data.ok == 1) {
                this.$message({
                  type: "success",
                  message: "Updated!",
                });
                this.loading = false;
                this.$router.go(-1);
              } else {
                this.$message({
                  type: "error",
                  message: "Update Failed!",
                });
                this.loading = false;
              }
            })
            .catch(function (error) {
              alert(error);
              this.loading = false;
            });
        }
      });
    },
  },
};
</script>

<style>
</style>
